export default "__VITE_ASSET__CH4AGaA5__"